import React from "react";
import {
  Grid,
  Typography,
  Paper,
  Button,
  Radio
} from "@mui/material";


const ChoiceQuestion = ({ questionData, update }) => {
  const [question, setQuestion] = React.useState(questionData);
  const [choice, setChoice] = React.useState(null);

  const handleUpdate = (action, answer) => {

    if (action === 'clear') {
      setChoice(null);
      update('clear', question._id);
      return
    } 

    setChoice(answer);
    update('add', question._id, answer);




  }


  return (
    <Grid item>
      <Paper elevation={1} style={{ padding: 10 }}>
      <Grid container spacing={0} justifyContent="center">
      {question?.choice1 ? (
        <Grid
          item
          xs={10}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
          onClick={() => handleUpdate('add', question?.choice1)}
        >
          <Typography variant="body1">{question?.choice1}</Typography>
          <Radio checked={choice === question?.choice1 ? true : false} />
        </Grid>
      ) : (
        <></>
      )}
      {question?.choice2 ? (
        <Grid
          item
          xs={10}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onClick={() => handleUpdate('add', question?.choice2)}
        >
          <Typography variant="body">{question?.choice2}</Typography>
          <Radio checked={choice === question?.choice2 ? true : false} />
        </Grid>
      ) : (
        <></>
      )}
      {question?.choice3 ? (
        <Grid
          item
          xs={10}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onClick={() => handleUpdate('add',question?.choice3)}
        >
          <Typography variant="body1">{question?.choice3}</Typography>
          <Radio checked={choice === question?.choice3 ? true : false} />
        </Grid>
      ) : (
        <></>
      )}
      {question?.choice4 ? (
        <Grid
          item
          xs={10}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onClick={() => handleUpdate('add',question?.choice4)}
        >
          <Typography variant="body1">{question?.choice4}</Typography>
          <Radio checked={choice === question?.choice4 ? true : false} />
        </Grid>
      ) : (
        <></>
      )}
      {question?.choice5 ? (
        <Grid
          item
          xs={10}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          onClick={() => handleUpdate('add', question?.choice5)}
        >
          <Typography variant="body1">{question?.choice5}</Typography>
          <Radio checked={choice === question?.choice5 ? true : false} />
        </Grid>
      ) : (
        <></>
      )}
      {!choice ? (
        <></>
      ) : (
        <Grid item xs={10}>
          <Button
            variant="contained"
            style={{ width: "100%", marginTop: 15, marginBottom: 15 }}
            onClick={() => handleUpdate('clear')}
          >
            clear
          </Button>
        </Grid>
      )}
    </Grid>
      </Paper>
    </Grid>
  );
};

export default ChoiceQuestion;
